import { friendlyRange } from "./client-detail/compare/headlineTotals";

const lastDay = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return `${ym}-${String(new Date(y, m, 0).getDate()).padStart(2, "0")}`;
};

const shiftMonth = (ym, delta) => {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const buildPresets = (months) => {
  if (!months?.length) return [];
  const sorted = [...months].sort();
  const latest = sorted[sorted.length - 1];
  const first = sorted[0];
  const ytdStart = `${latest.slice(0, 4)}-01`;
  const clamp = (ym) => (ym < first ? first : ym);
  return [
    { key: "last-month", label: "Latest month", start: `${latest}-01`, end: lastDay(latest) },
    { key: "last-3", label: "Last 3 months", start: `${clamp(shiftMonth(latest, -2))}-01`, end: lastDay(latest) },
    { key: "ytd", label: "Year to date", start: `${clamp(ytdStart)}-01`, end: lastDay(latest) },
    { key: "all", label: "All time", start: `${first}-01`, end: lastDay(latest) },
  ];
};

const TONES = {
  light: { on: "bg-cyan-600 text-white", off: "bg-slate-100 text-slate-700 hover:bg-slate-200", subOn: "text-white/75", subOff: "text-slate-500" },
  onDark: { on: "bg-lime-300 text-slate-900", off: "bg-white/[0.06] text-slate-100 ring-1 ring-white/10 hover:bg-white/[0.12]", subOn: "text-slate-700", subOff: "text-slate-400" },
};

export const PresetButtons = ({ presets, active, onSelect, tone = "light" }) => {
  const t = TONES[tone];
  return (
    <div className="flex flex-wrap gap-2" data-testid="period-presets">
      {presets.map((p) => {
        const on = active === p.key;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => onSelect(p)}
            data-testid={`period-preset-${p.key}`}
            className={`flex flex-col items-start px-4 py-2 rounded-2xl text-left transition-colors duration-200 ${on ? t.on : t.off}`}
          >
            <span className="text-sm font-semibold">{p.label}</span>
            <span className={`text-[11px] ${on ? t.subOn : t.subOff}`}>{friendlyRange(p.start, p.end, true)}</span>
          </button>
        );
      })}
    </div>
  );
};
